"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SliderRangeFilter;
exports.SliderRange = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Filter = require("./Filter");

var _Slider = _interopRequireDefault(require("../Slider"));

var _View = _interopRequireDefault(require("../View"));

var _Text = _interopRequireDefault(require("../Text"));

var SliderRange =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(SliderRange, _PureComponent);

  function SliderRange() {
    (0, _classCallCheck2["default"])(this, SliderRange);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SliderRange).apply(this, arguments));
  }

  (0, _createClass2["default"])(SliderRange, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          range = _this$props.range,
          _onChange = _this$props.onChange,
          initialValue = _this$props.initialValue,
          currentValue = _this$props.currentValue,
          formatValue = _this$props.formatValue,
          formatLabel = _this$props.formatLabel;
      var displayValue = Object.assign({}, currentValue || initialValue);
      if (isNaN(displayValue.min) || displayValue.min === null) displayValue.min = range[0];
      if (isNaN(displayValue.max) || displayValue.max === null) displayValue.max = range[1];
      return _react["default"].createElement(_View["default"], {
        pr: 2,
        pl: 2
      }, formatLabel && _react["default"].createElement(_Text["default"], {
        fontSize: "small",
        textAlign: "center"
      }, formatLabel(displayValue)), _react["default"].createElement(_Slider["default"], {
        height: "medium",
        range: range,
        initialValue: displayValue,
        formatValue: formatValue,
        onChange: function onChange(_ref) {
          var value = (0, _extends2["default"])({}, _ref);
          if (value.min === range[0]) value.min = undefined;
          if (value.max === range[1]) value.max = undefined;
          if (value.max === undefined && value.min === undefined) _onChange(undefined);else _onChange(value);
        },
        trackProps: {
          bg: 'lightGrey'
        }
      }, _react["default"].createElement(_Slider["default"].Marker, {
        name: "min"
      }), _react["default"].createElement(_Slider["default"].Marker, {
        name: "max",
        trackProps: {
          bg: 'pink'
        }
      })));
    }
  }]);
  return SliderRange;
}(_react.PureComponent);

exports.SliderRange = SliderRange;

function SliderRangeFilter(props) {
  return _react["default"].createElement(_Filter.ControlledFilter, props, function (_ref2) {
    var field = _ref2.field;
    return _react["default"].createElement(SliderRange, (0, _extends2["default"])({}, field, props));
  });
}